<ng-template #template>
  <div class="rsm-dialog-shell rsm-confirm-dialog">
    <div class="rsm-dialog-header rsm-dialog-header--centered">
      <span></span>
      <button mat-icon-button class="rsm-dialog-close" (click)="onClonseButton()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <mat-dialog-content class="rsm-dialog-content rsm-confirm-dialog__content">
      <div class="rsm-confirm-dialog__icon icon-circle error-bg">
        <i class="fa-solid fa-triangle-exclamation text-error"></i>
      </div>
      
      <h6 class="rsm-dialog-title rsm-confirm-dialog__title">{{ title }}</h6>
      <p class="rsm-dialog-subtitle rsm-confirm-dialog__msg">{{ msg }}</p>
    </mat-dialog-content>

    <mat-dialog-actions align="center" class="rsm-dialog-actions rsm-confirm-dialog__actions">
      <button mat-stroked-button color="primary" class="cancel-btn" (click)="onClonseButton()">{{ cancelText }}</button>
      <button mat-raised-button color="primary" class="confirm-btn" (click)="onConfirmButton()">{{ confirmText }}</button>
    </mat-dialog-actions>
  </div>
</ng-template>
